import { getDefaultExportFromCjs as t } from "./_commonjsHelpers.js";
import { __require as r } from "../common/libs/splitText.min.js";
var e = /* @__PURE__ */ r();
const p = /* @__PURE__ */ t(e);
export {
  p as default
};
//# sourceMappingURL=splitText.min.js.map
